<script>
import VueTagsInput from '@johmun/vue-tags-input'
import { Cropper } from 'vue-advanced-cropper'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import store from '@state/store'

export default {
  name: 'ProductAdd',
  components: { VueTagsInput, Cropper, Treeselect },
  props: {
    currentCompanyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      price: '',
      stock: '',
      description: '',
      productPhoto: null,
      visibleImageCropper: false,
      toCropImage: false,
      buyNotifyEmails: '',
      tagsTag: '',
      autocompleteTagsItems: [],
      categoryTag: '',
      categoryTags: [],
      autocompleteCategoryItems: [],
      tagsTags: [],
      maxCategoryTags: 1,
      saveButtonText: 'Save',
      groupIds: this.selectedGroupIds,
      disabledSave: false,
    }
  },
  computed: {
    groups() {
      return this.$store.state.marketplace.groups || []
    },
    selectedGroupIds: {
      get: function() {
        return []
      },
      set: function(groupId) {
        this.groupIds = groupId
      },
    },
  },
  watch: {
    tagsTag: 'initTagsItems',
    categoryTag: 'initCategoryItems',
  },
  methods: {
    updateTags(newTags) {
      this.autocompleteTagsItems = []
      for (var i = 0; i < newTags.length; i++) {
        if (typeof newTags[i].name === 'undefined') {
          newTags[i].name = newTags[i].text
        }
      }
      this.tagsTags = newTags
    },
    initTagsItems() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('marketplace/fetchTagsStartingWith', {
            companyId: this.currentCompanyId,
            startingWith: this.tagsTag,
          })
          .then((response) => {
            this.autocompleteTagsItems = response.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    updateCategory(newTags) {
      this.autocompleteCategoryItems = []
      this.categoryTags = newTags
    },
    initCategoryItems() {
      if (
        this.maxCategoryTags > 0 &&
        this.categoryTags.length >= this.maxCategoryTags
      )
        return

      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('marketplace/fetchCategoriesStartingWith', {
            companyId: this.currentCompanyId,
            startingWith: this.categoryTag,
          })
          .then((response) => {
            this.autocompleteCategoryItems = response.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    clickOnFileUpload() {
      this.$refs.file.click()
    },
    uploadFiles(event) {
      var input = event.target
      if (input.files && input.files.length > 0) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.toCropImage = {
            original: e.target.result,
            cropped: null,
          }
        }
        reader.readAsDataURL(input.files[0])
        this.visibleImageCropper = true
      }
    },
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      this.toCropImage.cropped = canvas.toDataURL()
    },
    onClose() {
      this.visibleImageCropper = false
    },
    finishCropping() {
      this.crop()
      this.croppedImage = this.toCropImage.cropped
      this.productPhoto = this.croppedImage
      this.visibleImageCropper = false
    },
    save() {
      this.saveButtonText = 'Loading...'
      this.disabledSave = true
      var data = {}
      data.title = this.title
      data.company_id = this.currentCompanyId
      data.price = this.price
      data.stock = this.stock
      data.description = this.description
      data.image_url = this.productPhoto
      data.buy_notify_emails = this.buyNotifyEmails
      data.category = this.categoryTags
      data.tags = this.tagsTags
      data.group_ids = this.groupIds
      this.$emit('add-product', data)
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="product-edit bg-white rounded-xl mx-auto px-10 py-8 shadow-box relative left-0 overflow-hidden"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body
      ><h3 class="block italic font-brandon text-blue-darker text-35xl pb-6"
        >ADD PRODUCT</h3
      >
      <div class="pb-3">
        <div class="mb-3">
          <label for="title" class="block mb-3">Item Name: *</label>
          <input
            v-model="title"
            type="text"
            name="title"
            class="input"
            placeholder="Enter item name or title here"
          />
        </div>
        <div class="mb-3 flex justify-between">
          <div class="w-1/2 mr-3">
            <label for="price" class="block mb-3"
              >Cost <i>(in Kynd Points)</i>: *</label
            >
            <input
              v-model="price"
              type="number"
              name="price"
              class="input"
              placeholder="Enter item cost"
            />
          </div>
          <div class="w-1/2 ml-3">
            <label for="stock" class="block mb-3">Quantity: *</label>
            <input
              v-model="stock"
              type="text"
              name="stock"
              class="input"
              placeholder="If unlimited, leave blank"
            />
          </div>
        </div>
        <div class="mb-3">
          <label for="description" class="block mb-3">Item Details: *</label>
          <textarea
            v-model="description"
            type="text"
            name="description"
            class="input"
            placeholder="Enter item details and description"
          />
        </div>
        <div class="mb-3 w-5/12">
          <label for="image" class="block">Item Image: *</label>
          <div class="flex">
            <div
              class="relative"
              :class="[productPhoto ? 'w-6/12' : 'mb-4 w-2/12']"
            >
              <img
                :src="productPhoto"
                :class="[productPhoto ? 'w-36' : '']"
                class="mt-3.5 h-auto inline-block "
              />
              <div
                class="border border-blue-default rounded-full absolute p-2.5 bg-white w-10 h-10 cursor-pointer"
                :class="[
                  productPhoto ? 'right-0 bottom-0' : 'left-0 top-0 mt-1',
                ]"
                @click="clickOnFileUpload"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.494"
                  height="16.611"
                  viewBox="0 0 19.494 16.611"
                >
                  <g
                    id="Group_336"
                    data-name="Group 336"
                    transform="translate(-3 -2)"
                  >
                    <path
                      id="Path_180"
                      data-name="Path 180"
                      d="M19.774,18.611H5.72A2.72,2.72,0,0,1,3,15.891V8.347a2.72,2.72,0,0,1,2.72-2.72H7.08l.453-1.655A3.239,3.239,0,0,1,10.707,2h4.08a3.239,3.239,0,0,1,3.173,1.972l.453,1.655h1.36a2.72,2.72,0,0,1,2.72,2.72v7.544A2.72,2.72,0,0,1,19.774,18.611ZM5.72,6.534A1.813,1.813,0,0,0,3.907,8.347v7.544A1.813,1.813,0,0,0,5.72,17.7H19.774a1.813,1.813,0,0,0,1.813-1.813V8.347a1.813,1.813,0,0,0-1.813-1.813H18.06a.454.454,0,0,1-.453-.331l-.553-1.986a2.323,2.323,0,0,0-2.267-1.31h-4.08A2.323,2.323,0,0,0,8.44,4.217L7.892,6.2a.454.454,0,0,1-.453.331Z"
                    />
                    <path
                      id="Path_181"
                      data-name="Path 181"
                      d="M19.08,23.16a4.08,4.08,0,1,1,4.08-4.08,4.08,4.08,0,0,1-4.08,4.08Zm0-7.254a3.173,3.173,0,1,0,3.173,3.173A3.173,3.173,0,0,0,19.08,15.907Z"
                      transform="translate(-6.56 -7.106)"
                    />
                    <path
                      id="Path_182"
                      data-name="Path 182"
                      d="M35.36,16.72a1.36,1.36,0,1,1,1.36-1.36A1.36,1.36,0,0,1,35.36,16.72Zm0-1.813a.453.453,0,1,0,.453.453A.454.454,0,0,0,35.36,14.907Z"
                      transform="translate(-16.946 -6.56)"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div class="relative w-5/12">
              <button
                class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mb-1 absolute"
                :class="[productPhoto ? 'bottom-0' : 'left-0 top-0 mt-3']"
                @click="clickOnFileUpload"
              ></button>
              <input
                ref="file"
                type="file"
                class="hidden"
                accept="image/*"
                @change="uploadFiles($event)"
              />
              <BaseModalWindow
                modalcls="w-user-edit bg-white rounded-xl mx-10 px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
                :visible="visibleImageCropper"
                @close="onClose"
              >
                <template v-slot:body>
                  <div class="w-full mx-auto mt-12 mb-5">
                    <div class="">
                      <Cropper
                        v-if="toCropImage"
                        ref="cropper"
                        :stencil-props="{
                          aspectRatio: 7 / 4,
                        }"
                        classname="w-full"
                        :src="toCropImage.original"
                      />
                    </div>

                    <div class="mt-3">
                      <button
                        class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
                        @click="finishCropping"
                        >Done</button
                      >
                    </div>
                  </div>
                </template>
              </BaseModalWindow>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="buy_notify_emails" class="block mb-3"
            >Notification
            <i>(who should be notified when the item is purchased)</i>: *</label
          >
          <input
            v-model="buyNotifyEmails"
            type="text"
            name="buy_notify_emails"
            class="input"
            placeholder="Enter email addresses separated by commas."
          />
        </div>
        <div class="mb-3 flex justify-between">
          <div class="w-1/2 mr-3">
            <label for="price" class="block mb-3">Category: *</label>
            <VueTagsInput
              v-model="categoryTag"
              :tags="categoryTags"
              :autocomplete-items="autocompleteCategoryItems"
              :autocomplete-min-length="2"
              :add-only-from-autocomplete="false"
              :add-on-key="[13, ',']"
              :max-tags="maxCategoryTags"
              placeholder="Enter category to select or create"
              class="mx-auto"
              @tags-changed="updateCategory"
            />
          </div>
          <div class="w-1/2 ml-3">
            <label for="stock" class="block mb-3">Tags: *</label>
            <VueTagsInput
              v-model="tagsTag"
              :tags="tagsTags"
              :autocomplete-items="autocompleteTagsItems"
              :autocomplete-min-length="2"
              :add-only-from-autocomplete="false"
              :add-on-key="[13, ',']"
              placeholder="Enter item tag"
              class="mx-auto"
              @tags-changed="updateTags"
            />
          </div>
        </div>
        <label for="groups" class="block mb-3">Visibility: *</label>
        <Treeselect
          v-model="selectedGroupIds"
          :options="groups"
          :multiple="true"
          :flat="true"
          name="groups"
          value-consists-of="BRANCH_PRIORITY"
        >
          <label slot="option-label" slot-scope="{ node }">
            {{ node.raw.name }}
          </label>
          <div slot="value-label" slot-scope="{ node }">{{
            node.raw.name
          }}</div>
        </Treeselect>
        <div class="mt-3">
          <button
            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
            :disabled="disabledSave"
            @click="save"
            >{{ saveButtonText }}</button
          >
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
            @click="$emit('close')"
            >Cancel</button
          >
        </div>
      </div>
    </template>
  </BaseModalWindow>
</template>
